import { Breakdown } from "@xola/ui-kit";
import React from "react";
import { LineItem } from "types";
import { getColor, getPriceAndQuantity } from "./utils";
import { NoTranslate } from "@/components/Common/NoTranslate";

/** Regex for coupon line item name in format Coupon (<CODE>) */
const couponNameRegex = /^coupon \([a-z\d]+\)$/i;

export const CouponLineItem = ({ lineItem }: { lineItem: LineItem }) => {
    return (
        <Breakdown.Item
            secondary={getPriceAndQuantity(lineItem)}
            value={-1 * Math.abs(lineItem.amount)}
            color={getColor(lineItem)}
            data-testid="coupon-line-item"
            classNames={{ info: "no-translate" }}
        >
            <CouponLineItemNameRenderer name={lineItem.name} />
        </Breakdown.Item>
    );
};

const CouponLineItemNameRenderer = ({ name }: { name: string }) => {
    // API is returning coupon in format Coupon (<Code>), to translate it
    // first we will check if it is in above format, then we will
    // split it and add no-translate only on code
    const isDefaultCouponText = couponNameRegex.test(name);
    if (!isDefaultCouponText) {
        return <span className="no-translate">{name}</span>;
    }

    const couponString = name.split(" ");

    return (
        <span>
            {couponString?.[0]} <NoTranslate>{couponString?.[1]}</NoTranslate>
        </span>
    );
};
